<template>
  <div>
    <mdb-container class="main-container">
        <section class="mt-5 mb-3">
            <mdb-row class="">
                <mdb-col md="12" class="text-center">
                    <div class="content-logo text-center mb-5">
                      <img class="logo-main" :src="imgLogo" alt="ULKite.ru">
                    </div>
                  <h1 class="h1-responsive mt-5 mb-4"><strong>Кайтинг в Ульяновске</strong></h1>
                    <h3 class="h3-responsive pb-5">Сайт для ветро зависимых людей</h3>
                </mdb-col>
            </mdb-row>
        </section>
        <section class="text-center mb-5">
            <mdb-row>
                <mdb-col md="4">
                    <mdb-icon icon="book" size="3x" class="red-text"/>
                  <h5 class="h5-responsive my-4 red-text"><strong>Начинающим</strong></h5>
                    <p class="mb-md-0 mb-5">
                        Самая полезная информация для начинающего кайтера. <br>С чего <router-link to="/begin/">начать</router-link>?
                    </p>
                </mdb-col>
                <mdb-col md="4">
                    <mdb-icon icon="exchange" size="3x" class="cyan-text"/>
                  <h5 class="h5-responsive my-4 cyan-text"><strong>Споты</strong></h5>
                    <p class="mb-md-0 mb-5">Обзор самых популярных и обкатанных <router-link to="/spots/">спотов</router-link> города и области.</p>
                </mdb-col>
                <mdb-col md="4">
                    <mdb-icon icon="envelope" size="3x" class="orange-text"/>
                  <h5 class="h5-responsive my-4 orange-text"><strong>Контакты</strong></h5>
                    <p class="mb-md-0 mb-5">Любой вопрос найдет отклик в <router-link to="/contacts/">сообществе</router-link> кайтеров региона.</p>
                </mdb-col>
            </mdb-row>
        </section>
      <!--<mdb-carousel class="main-page-carousel" :interval="8000" showControls showIndicators>
        <mdb-carousel-item img :src="slide1" alt="Сноукайтинг на бескрайних просторах Волги" mask="black-light">
          <mdb-carousel-caption title="Сноукайтинг на бескрайних просторах Волги" text=""></mdb-carousel-caption>
        </mdb-carousel-item>
        <mdb-carousel-item img :src="slide2" alt="Нет никаких преград на пути" mask="black-light">
          <mdb-carousel-caption title="Нет никаких преград на пути" text="кроме моста..."></mdb-carousel-caption>
        </mdb-carousel-item>
        <mdb-carousel-item img :src="slide3" alt="Ледоход не помеха для виндсерфинга" mask="black-light">
          <mdb-carousel-caption title="Ледоход не помеха для виндсерфинга" text=""></mdb-carousel-caption>
        </mdb-carousel-item>
      </mdb-carousel>-->
  </mdb-container>
</div>
</template>

<script>
import { mdbContainer, mdbRow, mdbCol, mdbCarousel, mdbCarouselItem, mdbCarouselCaption, mdbIcon } from 'mdbvue'
import imgLogo from '../../assets/logo/logo.svg'
import slide1 from '../../assets/bg/bg-1.jpg'
import slide2 from '../../assets/bg/bg-2.jpg'
import slide3 from '../../assets/bg/bg-3.jpg'

export default {
  name: 'MainPage',
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCarousel,
    mdbCarouselItem,
    mdbCarouselCaption,
    mdbIcon
  },
  data: function () {
    return {
      imgLogo: imgLogo,
      slide1: slide1,
      slide2: slide2,
      slide3: slide3
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/MainPage.vue